import { render, staticRenderFns } from "./YtFileDisplay.vue?vue&type=template&id=30bbaf83&scoped=true&"
import script from "./YtFileDisplay.vue?vue&type=script&lang=js&"
export * from "./YtFileDisplay.vue?vue&type=script&lang=js&"
import style0 from "./YtFileDisplay.vue?vue&type=style&index=0&id=30bbaf83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bbaf83",
  null
  
)

export default component.exports